import { SectionAlert, Txt } from '@vst/beam';
import { CalendarToday } from '@vst/beam-icons/icons';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { DateFormat } from '@app/constants';
import { SelectedDate } from '@app/hooks';
import { formatTimeInterval } from '@app/redux/scheduleInstallation';

import { ScheduleInput } from '@mfe/shared/schema-types';

export enum ScheduleAlertAction {
  DateAndTimeRequired = 'dateAndTimeRequired',
  TimeRequired = 'timeRequired',
  DateAndTimeConfirmed = 'dateAndTimeConfirmed',
}

type ScheduleInstallationAlertProps = {
  action: ScheduleAlertAction;
  selectedDate: SelectedDate;
  selectedInterval: ScheduleInput | null;
};

export const ScheduleInstallationAlert = ({
  action,
  selectedDate,
  selectedInterval,
}: ScheduleInstallationAlertProps) => {
  const { t } = useTranslation('ScheduleInstallation', {
    keyPrefix: 'ScheduleInstallationAlert',
  });

  const formattedDate =
    selectedDate.day &&
    selectedDate.month &&
    selectedDate.year &&
    format(new Date(selectedDate.year, selectedDate.month - 1, selectedDate.day), DateFormat.SHORT_MONTH_DAY);

  switch (action) {
    case ScheduleAlertAction.DateAndTimeRequired:
      return (
        <SectionAlert
          data-cy="alert-dateAndTimeRequired"
          variant="error"
          label={t('DateAndTimeRequiredAlert')}
          size="large"
        />
      );
    case ScheduleAlertAction.TimeRequired:
      return <SectionAlert data-cy="alert-timeRequired" variant="error" label={t('TimeRequiredAlert')} size="large" />;
    case ScheduleAlertAction.DateAndTimeConfirmed:
      return (
        <SectionAlert
          data-cy="alert-dateAndTimeConfirmed"
          variant="success"
          contentSlot={
            <div>
              <Txt color="regular" component="span" variant="smallRegular">
                {t('ConfirmationAlert.selectionMessage')}
              </Txt>
              <Txt color="regular" component="span" variant="smallBold">
                {t('ConfirmationAlert.dateBetweenTime', {
                  DATE: formattedDate,
                  TIME: formatTimeInterval([selectedInterval?.from ?? '', selectedInterval?.to ?? '']),
                })}
              </Txt>
            </div>
          }
          icon={CalendarToday}
          size="large"
        />
      );
    default:
      return null;
  }
};
